import html from "./InstructionStep.html"

var module = angular.module("ResearchKitApplicationModule");

module.directive("instructionStep", ['ceUrl',
	function (ceUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}]
);
module.controller("instructionStepController", ["$scope",
	function ($scope) {
		const nullFunction = () => {};

		let formProps = null;
		$scope.getFormProps = function () {
			var newFormProps = {
				key: $scope.stepManager.step.identifier,
				formItems: $scope.stepManager.getFormItems(),
				results: [...$scope.stepManager.childResults],
				onResultChange: nullFunction,
				onEnterPressed: nullFunction,
				variant: $scope.stepManager.getFormStyle(),
				contentItemSettings: $scope.stepManager.getContentItemSettings()
			};
			if (!angular.equals(newFormProps, formProps)) {
				formProps = newFormProps;
			}
			return formProps;
		}
	}
]);
module.factory("InstructionStepManager", ["FormStepManager", function (FormStepManager) {

	function InstructionStepManager(step, surveyManager) {
		if(!step.formItems) {
			step.formItems = [];
		}
		FormStepManager.call(this, step, surveyManager);
	}

	InstructionStepManager.prototype = Object.create(FormStepManager.prototype);

	InstructionStepManager.prototype.isLastInstructionStep = function () {
		if (this.surveyManager.editMode) {
			return false;
		}

		for (var i = 0; i < this.surveyManager.managedStepIdentifiers.length; i++) {
			var identifier = this.surveyManager.managedStepIdentifiers[i];
			var step = _.findWhere(this.surveyManager.template.steps, { identifier: identifier });
			if (step.type != 'InstructionStep') {
				return false;
			}
		}

		var nextStep = this.surveyManager.nextStep();
		if (nextStep && nextStep.type != 'InstructionStep') {
			return true;
		}
		return false;
	}

	InstructionStepManager.prototype.hideNextButton = function () {
		if (!this.surveyManager.linkSurvey && !this.surveyManager.editMode) {
			return false;
		}
		return this.step.hideNextButton;
	}

	return InstructionStepManager;
}]);